import { client } from "@lib/api"
import useSWR from "swr"

export type SystemHealth = {
    subsystem: string
    status: "OPERATIONAL" | "PARTIAL_OUTAGE" | "MAJOR_OUTAGE"
    warning_text: string,
    manual_override: boolean,
    created_at: string,
    updated_at: string
}

const useSystemHealth = () => {
    const { data, isLoading, error } = useSWR('/system/status', client.doUnauthenticatedGet)

    return {
        data: data && data.length ? data.filter((item: SystemHealth) => 
            item.status.toLocaleUpperCase() !== "OPERATIONAL" && 
            item.subsystem !== "Solana"
        ) as SystemHealth[] | undefined : undefined,
        isLoading,
        error
    }
}

export default useSystemHealth